// Simple event system for cross-component credit updates
export interface CreditUpdateEvent {
  userId: string;
  action: 'adjust' | 'grant';
}

export const creditsEvents = {
  emit: (event: CreditUpdateEvent) => {
    window.dispatchEvent(new CustomEvent('credits:updated', { detail: event }));
  },

  subscribe: (callback: (event: CreditUpdateEvent) => void) => {
    const handler = (e: Event) => {
      const customEvent = e as CustomEvent<CreditUpdateEvent>;
      callback(customEvent.detail);
    };
    
    window.addEventListener('credits:updated', handler);
    
    return () => {
      window.removeEventListener('credits:updated', handler);
    };
  }
};